import type { ReactElement } from 'react'
import type { IAppSummary } from '~/types/application'

import { VersionArchiveEngine } from '../Engines'

import { ENGINE_TYPE } from '~/types/arbitration'

interface Props {
  selectedApp: IAppSummary
}

const VersionEngine = ({ selectedApp }: Props): ReactElement => (
  <VersionArchiveEngine engineType={ENGINE_TYPE.VERSION} selectedApp={selectedApp} />
)

export default VersionEngine
